import {
    createUserWithEmailAndPassword,
    getAuth, signInWithEmailAndPassword, signInWithPopup,
    signOut, updateProfile
} from "firebase/auth";

import Swal from "sweetalert2";
import { googleAuthProvider } from "../firebase/firebase-config";
import { types } from "../types/types"
import { finishLoading, removeError, setError, startLoading } from "./ui";

const auth = getAuth()

export const startLoginEmailPassword = (email, password) => {
    return async (dispatch) => {

        dispatch(startLoading())

        try {
            const { user } = await signInWithEmailAndPassword(auth, email, password)

            dispatch(login(user.uid, user.displayName))

            dispatch(removeError())

        } catch (error) {
            dispatch(setError('Email or password is wrong.'))

            console.log(error)
            Swal.fire('Error', 'Email or password is wrong.', 'error')
            
        } finally {
            dispatch(finishLoading())
        }
    }
}

export const startGoogleLogin = () => {
    return async (dispatch) => {
        try {
            const { user } = await signInWithPopup(auth, googleAuthProvider)

            dispatch(login(user.uid, user.displayName))

        } catch (error) {
            console.log(error)
        } 
    }
}

export const startRegister = (email, password, name) => {
    return async (dispatch) => {

        try {
            const { user } = await createUserWithEmailAndPassword(auth, email, password)

            await updateProfile(user, { displayName: name })

            dispatch(login(user.uid, user.displayName))

        } catch (error) {
            console.log(error)
        }
    }
}

export const login = (uid, displayName) => {
    return {
        type: types.login,
        payload: {
            uid,
            displayName
        }
    }
}

export const startLogout = () => {
    return async (dispatch) => {

        try {
            await signOut(auth)

        } catch (error) {
            throw new Error(error)
        }

        dispatch(logout())
    }
}

const logout = () => {
    return {
        type: types.logout
    }
}